__turbopack_context__.v({
  "animate": "Flashcard-module___EMzqG__animate",
  "blank": "Flashcard-module___EMzqG__blank",
  "changeBg": "Flashcard-module___EMzqG__changeBg",
});
